import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';

import { Dropdown } from 'components';

import {
  setFocus,
  clearFocus,
  setRequiredField,
  unsetRequiredField,
} from 'store/actions';

export const OPTIONS = 0;
export const ACTION = 1;
export const SELECTED = 2;

export default (fields) => {
  class DropdownContainer extends React.Component {
    static propTypes = {
      field: PropTypes.string.isRequired,
    }
    constructor(props) {
      super(props);
      if (!fields[props.field]) throw new Error(`Unsupported field: ${props.field}`);
    }
    render = () => <Dropdown {...this.props} />;
  }

  const mapStateToProps = (state, { nullable, defaultText, field, ...props }) => {
    const optionsFromState = fields[field][OPTIONS](state, props);
    const options = nullable ? [{ code: null, text: defaultText }, ...optionsFromState] : optionsFromState;

    let readOnly = false;

    const cabinsAllocated = fromReservation.isCabinsAllocated(state, fromReservation.getActiveDepartureId(state));
    if (cabinsAllocated && (field === 'gender' || field === 'customerCategory')) {
      readOnly = true;
    }
    const checkInStarted = fromReservation.isCheckInStarted(state, fromReservation.getActiveDepartureId(state));
    if (checkInStarted) {
      readOnly = true;
    }

    return {
      selected: fields[field][SELECTED](state, props),
      options,
      readonly: readOnly,
    };
  };
  const mapDispatchToProps = (dispatch, { field, ...props }) => ({
    onSelect: value => dispatch(fields[field][ACTION](value, props)) && dispatch(clearFocus()),
    onFocus: () => props.required && dispatch(setFocus(props.guestId, field, props.departureId)),
    onBlur: () => props.required && dispatch(clearFocus()),
    setRequiredField: () => dispatch(setRequiredField(props.guestId, field)),
    unsetRequiredField: () => dispatch(unsetRequiredField(props.guestId, field)),
  });

  const component = connect(mapStateToProps, mapDispatchToProps)(DropdownContainer);

  component.propTypes = {
    nullable: PropTypes.bool,
  };

  component.defaultProps = {
    nullable: false,
  };

  return component;
};



// WEBPACK FOOTER //
// ./src/containers/factory/DropdownContainerFactory.js